import {
    SECRETARY_DELETE_FAILURE,
    SECRETARY_DELETE_REQUEST,
    SECRETARY_DELETE_SUCCESS,
} from 'actions';

const initialState = {
    deleting: false,
    hasErrors: false,
};

export default (state = initialState, action) => {
    const {type} = action;
    switch (type) {
        case SECRETARY_DELETE_SUCCESS: {return {
            ...state,
            deleting: false,
            hasErrors: false,
        }}

        case SECRETARY_DELETE_REQUEST: {return {
            ...initialState,
            deleting: true,
        }}

        case SECRETARY_DELETE_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: {return state}
    }
};
